import React, { useEffect, useState } from 'react'
import Lottie from '../lotties/lottie';

function FreeChipsHasBeenReceivedPopUp({ user, socket, localVideoIsChecked, amount }) {
    const[ showBanner, setShowBanner ] = useState( true )

    useEffect(()=>{
    },[ showBanner ])

    const closeBanner = () => { setShowBanner(false); };

    if( showBanner ){
        return(
            <div style={{ display: 'block' }}>
                <div className={'freeChipsPopUp' + amount + ' rotating-scaling'}>
                    <button className="purple_button cardButtonFreeChipsBannerDailyPosition" onClick={ closeBanner } >Take chips</button>
                </div>
                <Lottie
                    animationName = 'freeChipsPopUpSparkle'
                    loop = { false }
                    className = 'confettiBackground'
                />
                <div className='popupBackdrop'></div>
            </div>
        )
    }else{
        return( null )
    }
}

export default FreeChipsHasBeenReceivedPopUp;